document.addEventListener("DOMContentLoaded", function () {
  initializeMcSlideshows();
});

function initializeMcSlideshows() {
  const slideshowSections = document.querySelectorAll(".mc-slideshows");

  if (slideshowSections.length === 0) {
    return;
  }

  slideshowSections.forEach(function (section) {
    const swiperContainer = section.querySelector(".mc-slideshows__swiper");
    const slides = section.querySelectorAll(".mc-slideshows__slide");

    if (!swiperContainer || slides.length === 0) {
      return;
    }

    const pagination = section.querySelector(
      ".mc-slideshows__swiper-pagination"
    );
    const prevButton = section.querySelector(
      ".mc-slideshows__swiper-button-prev"
    );
    const nextButton = section.querySelector(
      ".mc-slideshows__swiper-button-next"
    );

    const swiper = new Swiper(swiperContainer, {
      // Core settings
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      grabCursor: true,
      allowTouchMove: true,
      preventClicks: false,
      preventClicksPropagation: false,

      // Pagination
      pagination: {
        el: pagination,
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },

      // Navigation arrows
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      // Effects
      effect: "slide",
      speed: 600,

      // Lazy loading
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },

      // Accessibility
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
      },

      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // Mouse wheel
      mousewheel: {
        forceToAxis: true,
      },
    });
  });
}
